module.exports = __webpack_public_path__ + "static/Abacus Zeiterfassung Funktionen LEHMANNPARTNER-84ace127586fae6934bc2d3190e10e80.pdf";